/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Coinvestments_Dataroom_Uploadingfiles3Inputs */

const en_coinvestments_dataroom_uploadingfiles3 = /** @type {(inputs: Coinvestments_Dataroom_Uploadingfiles3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading ${i?.completed}/${i?.total} files...`)
};

/**
* | output |
* | --- |
* | "Uploading {completed}/{total} files..." |
*
* @param {Coinvestments_Dataroom_Uploadingfiles3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_uploadingfiles3 = /** @type {((inputs: Coinvestments_Dataroom_Uploadingfiles3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Uploadingfiles3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_uploadingfiles3(inputs)
});
export { coinvestments_dataroom_uploadingfiles3 as "coInvestments_dataRoom_uploadingFiles" }